import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import TableSkeletonRows from "components/shared/TableSkeletonRows";
import { useCompanySettings } from "hooks/useCompanySettings";
import { useTranslation } from "react-i18next";

import variables from "../../../assets/styles/_variables.module.scss";
import "./style.scss";

const tHeadStyles = {
    maxWidth: 200,
    fontWeight: 600,
    fontSize: "12px",
    color: "#676767",
    width: "min-content",
    padding: "10px 20px",
    backgroundColor: "#F6F6F6",
    fontFamily: "'Poppins', sans-serif",
    minWidth: "140px",
};

const SKELETON_ROW_COUNT = 5;
const SKELETON_COLUMN_COUNT = 4;

const DataAtCreationSkeleton = () => {
    const [t] = useTranslation();
    const { getCompanySettings } = useCompanySettings();
    const usesStocks = getCompanySettings("uses_stock");

    return (
        <>
            {usesStocks && (
                <div className="tab-other-quantity-wrapper">
                    <span className="tab-other-quantity" style={{ margin: 18, fontSize: 13, color: "#6f6f6f" }}>
                        <Skeleton variant="text" width={200} />
                    </span>
                </div>
            )}
            <Paper
                sx={{
                    width: "100%",
                    overflow: "hidden",
                    border: `1px solid ${variables["border-grey"]}`,
                    borderRadius: variables["border-raduis"],
                    boxShadow: "none",
                    marginTop: "16px",
                }}
            >
                <TableContainer>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={tHeadStyles}>{t("Titles.Channels")}</TableCell>
                                <TableCell sx={{ ...tHeadStyles, textAlign: "center" }}>
                                    {t("CalculationBaseColumnLabels.Columns.quantity")}
                                </TableCell>
                                <TableCell sx={{ ...tHeadStyles, textAlign: "center" }}>
                                    {t("CalculationBaseColumnLabels.Columns.turnover")}
                                </TableCell>
                                <TableCell sx={tHeadStyles} />
                            </TableRow>
                        </TableHead>
                        <TableBody className="table-start-channel-data">
                            <TableSkeletonRows
                                rowCount={SKELETON_ROW_COUNT}
                                columnCount={SKELETON_COLUMN_COUNT}
                                rowHeight={44}
                            />
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    );
};

export default DataAtCreationSkeleton;
